import React, { useState, useEffect } from "react";
import { Select, Row, Col, Spin, Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../../utils/routes";
import { SORT_OPTIONS } from "../../../../utils/constantOptions";
import useFirmService from "../../../../services/useFirmService";
import JobCard from "../../Components/JobCard";

const { Option } = Select;
const DEFAULT_SORT = "ADVERT_START_DATE_DESC";
const PAGE_SIZE = 10;

const styles = {
  container: {
    padding: 24,
  },
  sortContainer: {
    marginBottom: 16,
  },
  advertList: {
    minHeight: 200,
  },
  rangeText: {
    marginBottom: 16,
    color: "#666",
    fontSize: 14,
  },
  paginationWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    marginTop: 16,
  },
};

const FirmActiveAdverts = ({ deleteAdvert }) => {
  const navigate = useNavigate();
  const [sortOption, setSortOption] = useState(DEFAULT_SORT);
  const [page, setPage] = useState(1);
  const [advertsData, setAdvertsData] = useState({
    data: [],
    total: 0,
  });

  const { useGetFirmAdverts } = useFirmService();
  const { mutateAsync: fetchAdverts, isPending } = useGetFirmAdverts();

  const getItemRangeText = () => {
    const start = (page - 1) * PAGE_SIZE + 1;
    const end = Math.min(page * PAGE_SIZE, advertsData.total);
    return `${advertsData.total} ilan arasından, ${start}-${end} arasındakiler gösteriliyor`;
  };

  const fetchAdvertData = async (
    currentPage = page,
    currentSort = sortOption
  ) => {
    const selectedSort = SORT_OPTIONS.find(
      (option) => option.value === currentSort
    );

    const requestBody = {
      pagination: {
        page: currentPage - 1,
        size: PAGE_SIZE,
      },
      fields: {
        isActive: true,
      },
      orderBy: selectedSort.orderBy,
      sortDirection: selectedSort.direction,
    };

    try {
      const response = await fetchAdverts(requestBody);
      setAdvertsData({
        data: response.data.pagination.data,
        total: response.data.pagination.total,
      });
    } catch (error) {
      console.error("Error fetching active adverts:", error);
    }
  };

  const handleSortChange = (value) => {
    setSortOption(value);
    setPage(1);
    fetchAdvertData(1, value);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchAdvertData(newPage);
  };

  const onAdvertClick = (id) => {
    navigate(`${PageRoutes.advertDetailFirm}/${id}`);
  };

  useEffect(() => {
    fetchAdvertData();
  }, []);

  return (
    <div style={styles.container}>
      <Row gutter={[16, 16]} style={styles.sortContainer}>
        <Col xs={24} sm={12}>
          <Select
            value={sortOption}
            onChange={handleSortChange}
            style={{ width: 250 }}
            placeholder="Sıralama seçiniz">
            {SORT_OPTIONS.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>

      <div style={styles.advertList}>
        <Spin spinning={isPending}>
          {advertsData.data.length > 0 && (
            <div style={styles.rangeText}>{getItemRangeText()}</div>
          )}
          {advertsData.data.map((advert) => (
            <JobCard
              deleteAdvert={deleteAdvert}
              key={advert.id}
              onClick={() => onAdvertClick(advert.id)}
              advertDetails={advert}
            />
          ))}
          {advertsData.data.length > 0 && (
            <div style={styles.paginationWrapper}>
              <Pagination
                current={page}
                total={advertsData.total}
                pageSize={PAGE_SIZE}
                onChange={handlePageChange}
                showSizeChanger={false}
              />
            </div>
          )}
        </Spin>
      </div>
    </div>
  );
};

export default FirmActiveAdverts;
